"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainScopes = exports.ExternalVendorEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["ExternalVendorEvent"] = "ExternalVendorEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var ExternalVendorEventActions;
(function (ExternalVendorEventActions) {
    ExternalVendorEventActions["ExternalVendorCreated"] = "ExternalVendorCreated";
    ExternalVendorEventActions["ExternalVendorDeleted"] = "ExternalVendorDeleted";
    ExternalVendorEventActions["CreateExternalVendor"] = "CREATE_VENDOR";
    ExternalVendorEventActions["DeleteExternalVendor"] = "DELETE_VENDOR";
})(ExternalVendorEventActions = exports.ExternalVendorEventActions || (exports.ExternalVendorEventActions = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyExternalVendorChanges"] = "MyExternalVendorChanges";
})(DomainScopes = exports.DomainScopes || (exports.DomainScopes = {}));
